import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "../lib/api.js";
import { errors } from "../copy/errors.js";
import { ListEditor, type ListEditorValues } from "../components/ListEditor.js";
import { useSession } from "../session.js";

export function ListNewScreen() {
  const navigate = useNavigate();
  const { membership } = useSession();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const save = async (values: ListEditorValues, visibility: "private" | "class" | null) => {
    setError(null);
    setBusy(true);
    try {
      const list = await api<{ id: string }>("/api/lists", {
        method: "POST",
        body: JSON.stringify({
          title: values.title,
          lang_b: values.langB,
          due_date: values.dueDate,
          source_hint: values.sourceHint,
          visibility: visibility ?? "private",
          items: values.items,
        }),
      });
      navigate(`/lists/${list.id}`);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : errors.failed);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ListEditor
      mode="create"
      backTo="/"
      canShare={Boolean(membership)}
      busy={busy}
      error={error}
      onSubmit={(values, visibility) => void save(values, visibility)}
    />
  );
}
